// DataProvider/datesPriceDataProvider.ts
const token = process.env.REACT_APP_API_KEY as string | undefined;
const API_URL = process.env.REACT_APP_API_URL as string | undefined;

if (!API_URL) {
  // eslint-disable-next-line no-console
  console.warn("[datesPriceDataProvider] Missing REACT_APP_API_URL env var");
}

// --- helper GET générique (pas de credentials, no-store pour éviter 304) ---
const apiGet = async (
  path: string,
  opts: { withCredentials?: boolean } = {}
) => {
  const r = await fetch(`${API_URL}${path}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: "Bearer " + token } : {}),
    },
    credentials: opts.withCredentials ? "include" : "omit",
    cache: "no-store",
  });

  let data: any = null;
  try {
    // 304 => pas de body; ça lèvera, on catch juste en dessous
    data = await r.json();
  } catch {
    data = null;
  }

  if (!r.ok) {
    const msg = (data && (data.message || data.error)) || `HTTP ${r.status}`;
    throw new Error(msg);
  }
  return data;
};

// --- endpoints existants ---
const getAllPriceCure = async () => apiGet(`/price`);

const getPriceByDates = async (
  room_id: number,
  start_date: string,
  end_date: string,
  stay_id: number
) => apiGet(`/bedroom_price/${room_id}/${start_date}/${end_date}/${stay_id}`);

const getAllPricesByDates = async (
  start_date: string,
  end_date: string,
  stay_id: number | string
) => apiGet(`/bedroom_price/${start_date}/${end_date}/${stay_id}`);

const getAllMyPrice = async (start_date: string, end_date: string) =>
  apiGet(`/bedroom_price_all/${start_date}/${end_date}`);

const getAllRooms = async () => apiGet(`/room_category`);

const getAllDiscount = async () => apiGet(`/discount`);

const getRoomPrice = async (room_id: number) =>
  apiGet(`/room_category/${room_id}`);

// --- codes promo ---
const getAllDiscountCode = async () => apiGet(`/DiscountCode`);

/** Valider/récupérer un code par son texte + hotelId (route back actuelle) */
const getDiscountCodeByCode = async (code: string, hotelId?: number) => {
  const normalized = (code || "").trim().toUpperCase();
  const qs = hotelId != null ? `?hotelId=${encodeURIComponent(String(hotelId))}` : "";
  const path = `/discount-codes/${encodeURIComponent(normalized)}${qs}`;
  return apiGet(path);
};

// --- provider exporté ---
const datesPriceDataProvider = {
  getPriceOption: async (price: string) => {
    if (price === "price") return getAllPriceCure();
    throw new Error(`Unsupported resource: ${price}`);
  },

  getPriceByDate: async (
    datePrice: string,
    room_id: number,
    start_date: string,
    end_date: string,
    stay_id: number
  ) => {
    if (datePrice === "datePrice")
      return getPriceByDates(room_id, start_date, end_date, stay_id);
    throw new Error(`Unsupported resource: ${datePrice}`);
  },

  getAllPriceByDate: async (
    datePrice: string,
    start_date: string,
    end_date: string,
    stay: number
  ) => {
    if (datePrice === "datePrice")
      return getAllPricesByDates(start_date, end_date, stay);
    throw new Error(`Unsupported resource: ${datePrice}`);
  },

  getMyPrice: async (datePrice: string, start_date: string, end_date: string) => {
    if (datePrice === "datePrice")
      return getAllMyPrice(start_date, end_date);
    throw new Error(`Unsupported resource: ${datePrice}`);
  },

  getDiscount: async () => getAllDiscount(),

  getAllDiscountCode: async () => getAllDiscountCode(),
  getDiscountCodeByCode: async (code: string, hotelId?: number) =>
    getDiscountCodeByCode(code, hotelId),

  getPriceByRoomCategory: async (roomPrice: string, room_id: number) => {
    if (roomPrice === "roomPrice") return getRoomPrice(room_id);
    throw new Error(`Unsupported resource: ${roomPrice}`);
  },

  getAllRoomCategory: async (roomPrice: string) => {
    if (roomPrice === "allRoom") return getAllRooms();
    throw new Error(`Unsupported resource: ${roomPrice}`);
  },
};

export default datesPriceDataProvider;
